import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, FormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { UserModelService } from '../../model/user-model/user-model.service';
import { ToastrService } from 'ngx-toastr';
import { FileUploader } from 'ng2-file-upload';
import { environment } from '../../../environments/environment';
import { CommonStatus, Globals, UserRole } from '../../globals/globals';
import { StoreService } from '../../model/store-model/store.service';
import SystemConstants from 'src/app/util/constants/SystemConstants';
import { CustomTypeAttribute, IGlobals, SystemConstantsType } from 'src/app/globals/custom-types/global-custom-types';
import StoreAPIModel from 'src/app/controller/store/store-api-model';
import { IInputLocationLocType } from 'src/app/interface/input-location/i-input-location-loc-type';
import { IStoreNotificationFilterKeys, NotificationApiModel, redirectLinkPath, slugConstants } from 'src/app/interface/notification/i-notfication';
import { CommonValidationService, CustomValidatorOptions } from 'src/app/util/service/common-validation.service';
import { GlobalService } from 'src/app/util/service/global.service';
import { Translations } from 'src/app/util/service/internationalization/translations.service';
import { LocalizationService, TranslationParams } from 'src/app/util/service/internationalization/localization.service';
import { ConditionalValidator } from 'src/app/util/validators/conditional-validator';
@Component({
    selector: 'app-sign-up',
    templateUrl: '../../view/sign-up/sign-up.component.html',
    styleUrls: ['../../view/sign-up/sign-up.component.scss'],
    standalone: false
})
export class SignUpComponent implements OnInit {
  /**
   * Define all controller property here
   */
  signUpForm: UntypedFormGroup;
  storeInfo: UntypedFormGroup;
  submitted = false;
  showPwd = false;
  imageCdn = environment.imageCdn.getHost;
  imageBaseUrl = environment.ImageBase;
  userData: any = {};
  storeAttributes: CustomTypeAttribute<IGlobals['adminPaginationAttrs'], any>;
  type = 'password';
  finalMsz = 'Welcome !!';
  formSteps = {
    currentStep: 'step1'
  };
  public uploader: FileUploader = new FileUploader({
    url: environment.apiUrl + '/user/upload-images'
  });
  keys = {
    STEP_1: 'step1',
    STEP_2: 'step2',
    STEP_3: 'step3'
  } as const;
  systemConstants: SystemConstantsType;
  nextButtonStatusToSumbit = false;
  // Add new property to store merchant data temporarily
  tempMerchantData: any = null;
  constructor(
    private fb: UntypedFormBuilder,
    private userModelService: UserModelService,
    private storeModelService: StoreService,
    private toastr: ToastrService,
    public globals: Globals,
    private validationService: CommonValidationService,
    public translations:Translations,
    private commonValidationService: CommonValidationService,
    private localizationService: LocalizationService,
    private globalService: GlobalService,


  ) { 
    this.initializeProperties();
  }

  ngOnInit() {
    this.initializeSignUpForm();
    this.getStoreCategoryList();
    this.setAttributesForFileUploader();
  }

  initializeProperties() {
    this.systemConstants = SystemConstants;
    this.storeAttributes = Object.assign({}, this.globals.adminPaginationAttrs);
  }

  
  setAttributesForFileUploader() {
    this.uploader.onAfterAddingFile = (file: any) => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      const res = JSON.parse(response);
      if (res.status === SystemConstants.OKAY_MSG && res.data[0] && res.data[0].filename) {
        this.selectedAvtarAndImage(res.data[0].filename);
      } else {
        if (res && res.status === this.systemConstants.ERROR_MSG) {
          console.error(res);
        }
      }
    };
  }
  trimAndValidate(validator: ValidatorFn): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (typeof control.value === 'string') {
        const trimmedValue = control.value.trim();
        if (trimmedValue !== control.value) {
          control.setValue(trimmedValue, { emitEvent: false });
        }
      }
      return validator(control);
    };
  }
  
  selectedAvtarAndImage(img: string) {
    this.signUpForm.patchValue({
      profileData: { image: img }
    });
  }
  /**
   * This method is used to initilaize the signup form controllers.
   */
  initializeSignUpForm(): void {
    this.signUpForm = this.fb.group({
      // fname: ['', this.commonValidationService.setCustomValidatorMethods({noAllWhiteSpaceValidation: true, isAlphabaticPattern: true, minLength:2, maxLength:25 })],
      // lname: ['', this.commonValidationService.setCustomValidatorMethods({noAllWhiteSpaceValidation: true, isAlphabaticPattern: true, minLength: 2, maxLength: 25})],
      fname: ['',Validators.required],
      lname: ['', Validators.required],
      // screenName: ['', [Validators.required, Validators.minLength(3), Validators.pattern(SystemConstants.NAME_REGEX)]],
      screenName: ['', ConditionalValidator(()=> this.screenName.value,Validators.required)],
      // username: ['', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true, minLength: 5,  maxLength: 25}), 
      username: [
        '',
        this.trimAndValidate(Validators.compose(
          this.commonValidationService.setCustomValidatorMethods({ noAllWhiteSpaceValidation: true })
        )),
        this.validationService.uniqueFieldValidator(
          this.userModelService.getUserIsUnique,
          SystemConstants.USERNAME,
          { thisRef: this.userModelService }
        )
      ],
      
      address: this.fb.group({
        formattedAddress: ['', Validators.required],
        // customAddress: ['',this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true, disableRequired: true})],
        customAddress: ['',this.commonValidationService.setCustomValidatorMethods({disableRequired: true})],
        // country: ['', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true})],
        country: ['', Validators.required],
        // city: ['', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true})],
        city: ['', Validators.required],
        // state: ['', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true})],
        state: ['', Validators.required],
        // postalCode: [ '', this.commonValidationService.setCustomValidatorMethods({noAllWhiteSpaceValidation: true, isAlphanumericPattern: true, minLength: 4, maxLength: 12})]
        postalCode: [
          '',
          [
            this.trimAndValidate(
              Validators.compose(
                this.commonValidationService.setCustomValidatorMethods({ isAlphanumericPattern: true })
              )!
            )
          ]
        ],
              }),
      // manuallAddress: this.fb.group({
      //   storeAddress1: ['', [Validators.required]],
      //   storeAddress2: ['', [Validators.required]],
      //   country: ['', [Validators.required]],
      //   city: ['', [Validators.required]],
      //   state: ['', [Validators.required]],
      //   postalCode: ['', [Validators.required, Validators.pattern(/^\d{6}(?:[-\s]\d{4})?$/)]]
      // }),
      profileData: this.fb.group({
        imageType: ['image', [Validators.required]],
        image: ['', Validators.required],
        mobileNumber: [
          '',
          [
            Validators.required,
            Validators.pattern(this.globals.phoneWithHyphenPattern)
          ]
        ],
        
        }),
      loc: this.fb.group({
        type: 'Point',
        coordinates: []
      }),
      userMetaData: this.fb.array([]),
      localeIds: this.fb.array([]),
      interests: this.fb.array([]),
      role: [UserRole.MERCHANT, [Validators.required]],
      status: [CommonStatus.PENDING, [Validators.required]],
      // email: ['', this.commonValidationService.setCustomValidatorMethods({maxLength: 64,noAllWhiteSpaceValidation:true,isEmailPattern:true}), 
      email: [
        '',
        [
          this.trimAndValidate(
            Validators.compose(
              this.commonValidationService.setCustomValidatorMethods({
                noAllWhiteSpaceValidation: true,
                isEmailPattern: true
              })
            )!
          )
        ],
        [
          this.validationService.uniqueFieldValidator(
            this.userModelService.getUserIsUnique,
            SystemConstants.EMAIL,
            { thisRef: this.userModelService }
          )
        ]
      ],
      
      
      
      
      
      // password: ['', this.commonValidationService.setCustomValidatorMethods({minLength:6,maxLength:20,noAllWhiteSpaceValidation:true,isAlphanumericPattern:true})
password: ['', [
  Validators.required,
  this.commonValidationService.strongPassword() 
]],    });
  }

  /**
   * This is used to get address control from signup form.
   */
  get userAddressForm(): any {
    const addForm = this.signUpForm.get('address') as UntypedFormGroup;
    return addForm.controls;
  }
  getCustomErrorMessage(formControl: AbstractControl, formControlName: string, options?: CustomValidatorOptions) {
    return this.commonValidationService.getCustomErrorMessage(formControl, formControlName, options);
  }
  getTranslation(key: string, options?: TranslationParams) {
    return this.localizationService.getTranslation(key, options)
  }
  /**
* This is used to get address control from signup form.
*/
  // get manuallAddressForm(): any {
  //   const addForm = this.signUpForm.get('manuallAddress') as FormGroup;
  //       return addForm.controls;
  // }


  //   enableGoogleAddress() {
  //     this.storeAttributes.defaultManuallAddress = false
  //     this.signUpForm.get('manuallAddress').disable()
  //     this.signUpForm.get('address').enable()
  // }

  // enableManuallAddress() {
  //   this.storeAttributes.defaultManuallAddress = true
  //   this.signUpForm.get('address').disable()
  //   this.signUpForm.get('manuallAddress').enable()
  // }

  /**
   * This is used to get profile data from signup form.
   */
  get userProfileDataForm(): any {
    const addForm = this.signUpForm.get('profileData') as UntypedFormGroup;
    return addForm.controls;
  }


  /**
 * This is used to get address control from signup form.
 */
  // get storeManuallAddressForm(): any {
  //   const addForm = this.storeInfo.get('storeManuallAddress') as FormGroup;
  //   return addForm.controls;
  // }


  // enableStoreGoogleAddress() {
  //     this.storeAttributes.manuallAddress = false
  //     this.storeInfo.get('storeManuallAddress').disable()
  //     this.storeInfo.get('storeAddress').enable()
  // }

  // enableStoreManuallAddress() {
  //   this.storeAttributes.manuallAddress = true
  //   this.storeInfo.get('storeAddress').disable()
  //   this.storeInfo.get('storeManuallAddress').enable()
  // }




  /**
   * This method is used to show and hide password
   */
  toggleToPasswordShow() {
    this.showPwd = !this.showPwd;
    if (this.showPwd) {
      this.type = 'text';
    } else { this.type = 'password'; }
  }

  /**
   * This method is used to format phone number as US format (XXX-XXX-XXXX)
   */
  formatPhoneNumber(event: any): void {
    this.globalService.formatPhoneNumber(event, this.signUpForm.get('profileData.mobileNumber'));
  }

  trimBeforeSumbit(){
      this.fname.setValue(this.fname.value.trim());
      this.lname.setValue(this.lname.value.trim());
  }

  /**
   * This method is used to submit for value to API.
   */

  onSubmit() {
    if(!this.nextButtonStatusToSumbit){
      this.nextButtonStatusToSumbit = true
    }else{
      return
    }
    this.trimBeforeSumbit();
    const data = this.signUpForm.value;
    this.signUpForm.patchValue({
      screenName: data.fname + '' + data.lname
    });
    if (this.signUpForm.invalid) {
      this.submitted = true;
      this.nextButtonStatusToSumbit = false
      return;
    }
   this.tempMerchantData = this.signUpForm.value;
    this.next(this.keys.STEP_2, this.signUpForm.valid);
    this.nextButtonStatusToSumbit = false;
  }

  /**
   * Used to create user record
   */
  createUserRecord(): Promise<void> {
    const queryObj: any = this.tempMerchantData || this.signUpForm.value;
    queryObj.fname = queryObj.fname.trim();
    queryObj.lname = queryObj.lname.trim();
    queryObj.screenName = queryObj.screenName.trim();
    
    return new Promise((resolve, reject) => {
      this.userModelService.createUser(queryObj).subscribe({
        next: (res) => {
          if (res && res.status === SystemConstants.OKAY_MSG) {
            this.toastr.success(SystemConstants.SUCCESS, SystemConstants.REGISTER_MSG);
            this.userData = res && res.data ? res.data : {};
            this.submitted = false;
            this.nextButtonStatusToSumbit = false;
            resolve();
          } else {
            this.toastr.error(SystemConstants.ERROR, res.errMsg);
            this.nextButtonStatusToSumbit = false;
            reject(new Error(res.errMsg));
          }
        },
        error: (err) => {
          if (err && err.errMsg) {
            this.toastr.error(SystemConstants.ERROR, err.errMsg);
          } else {
            this.toastr.error(SystemConstants.ERROR, SystemConstants.FAILED_TO_CREATE_USER);
          }
          this.nextButtonStatusToSumbit = false;
          reject(err);
        }
      });
    });
  }

  /**
   * This method is used to set User address with google autocomplete.
   * @param place any
   */

   setDefaultStoreAddressWithGoogleAddress(place: any) {
    if (place.address_components && place.address_components.length) {
      if (place.formatted_address) {
        this.storeInfo.patchValue({
          storeManuallAddress: { storeAddress1: place.formatted_address }
        });
      }
      let placeData;
      for (placeData of place.address_components) {
        this.storeInfo.patchValue({
          storeLoc: { coordinates: [place.geometry.location.lng(), place.geometry.location.lat()] }

        });
      }
    }

  } 
  
  
  /**
   * This method is used to set User address with google autocomplete.
   * @param place any
   */
   setDefaultAddressFieldsWithGoogleAddress(place: any) {
    if (place.address_components && place.address_components.length) {
      if (place.formatted_address) {
        this.signUpForm.patchValue({
          manuallAddress: { storeAddress1: place.formatted_address }
        });
      }
      let placeData;
      for (placeData of place.address_components) {

        this.signUpForm.patchValue({
          loc: { coordinates: [place.geometry.location.lng(), place.geometry.location.lat()] }
        });
      }
    }
  }
  
  
/**
   * Function for previous setps of from
   */
  previous(key) {
    this.formSteps.currentStep = key;
    // Clear temporary merchant data if going back to step 1
    if (key === this.keys.STEP_1) {
      this.tempMerchantData = null;
    }
  }

  /*
   * Function for to move next step and check validation
   */
  next(key, valid) {
    this.formSteps.currentStep = key;
    // if (valid) {
    // }
  }

  /*
  * Function for to move next step and check validation
  */
  triggerNextStep(event: {key: string, skip: boolean}) {
    this.formSteps.currentStep = event.key;
    if (event.skip) {
      this.finalMsz = SystemConstants.SIGN_UP_REGISTER_MSG;
      // If user skips store creation, still create the merchant account
      if (this.tempMerchantData && !this.userData._id) {
        this.createUserRecord().then(() => {
          this.toastr.success(SystemConstants.SUCCESS, SystemConstants.MERCHANT_CREATED);
        }).catch(error => {
          this.toastr.error(SystemConstants.ERROR, SystemConstants.FAILED_TO_CREATE);
        });
      }
    }
  }


  onImageSelect(event) {
    if (event && event.target && event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploader.uploadAll();
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  onCreateStore(store: StoreAPIModel): void {
    if (!this.tempMerchantData) {
      this.toastr.error(SystemConstants.ERROR, SystemConstants.MERCHANT_NOT_FOUND);
      return;
    }

    // First create the merchant, then create the store
    this.createUserRecord().then(() => {
      // After merchant is created successfully, create the store
      const notificationReqData = this.getNotificationReqDataQuery(store);
      store.merchantId = this.userData._id;
      this.storeModelService.createMerchantStore({...store, notificationReqData}).subscribe(res => {
        if (res && res.status === SystemConstants.OKAY_MSG) {
          this.toastr.success(SystemConstants.SUCCESS, SystemConstants.STORE_AND_MERCHANT_REGISTRATION_MSG);
          this.triggerNextStep({key: this.keys.STEP_3, skip: false});
        } else {
          this.toastr.error(SystemConstants.ERROR, res.errMsg);
        }
      }, err => {
        if (err && err.errMsg) {
          this.toastr.error(SystemConstants.ERROR, err.errMsg);
        }
      });
    }).catch(error => {
      this.toastr.error(SystemConstants.ERROR, SystemConstants.FAILED_TO_CREATE);
    });
  }

  /**
   * This is used to get store category list by passing limit, skip
   * @param limitNum number
   * @param skipNum number
   */
  getStoreCategoryList() {
    const queryObj: any = {};
    queryObj.status = CommonStatus.ACTIVE;
    this.storeModelService.getStoreCategoryList(queryObj).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.storeAttributes.pageItems = res.data;
      }
    }, err => {
    });
  }

  patchDataForLocFormGroup(locFormGroupData: IInputLocationLocType): void{
    this.signUpForm.patchValue(locFormGroupData);
  }

  private getNotificationReqDataQuery(store: StoreAPIModel): NotificationApiModel<IStoreNotificationFilterKeys> {
    return {
      slug: slugConstants.STORE_APPROVAL,
      filterKeys: {
        storeName: store.storeName,
        merchantFirstName: this.signUpForm.value.fname as string,
        merchantLastName: this.signUpForm.value.lname as string
      } as IStoreNotificationFilterKeys,
      userRole: [UserRole.SUPER_ADMIN],
      redirectLink: {
        web: redirectLinkPath.ADMIN_STORE
      }
    } as NotificationApiModel<IStoreNotificationFilterKeys>;
  }

  get fname():AbstractControl {
    return this.signUpForm.controls.fname;
  }

  get lname():AbstractControl {
    return this.signUpForm.controls.lname;
  }

  get username():AbstractControl {
    return this.signUpForm.controls.username;
  }

  get screenName():AbstractControl {
    return this.signUpForm.controls.screenName;
  }

  get email():AbstractControl {
    return this.signUpForm.controls.email;
  }

  get password():AbstractControl {
    return this.signUpForm.controls.password;
  }
}
